import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const InfoPanel = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  overflow: hidden;
`;

const PanelHeader = styled.div`
  padding: 20px 25px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 10px;
  
  h3 {
    font-size: 1.2em;
    color: #2c3e50;
    margin: 0;
  }
  
  i {
    color: #667eea;
  }
`;

const PanelContent = styled.div`
  padding: 25px;
`;

const EmbedDescription = styled.p`
  color: #7f8c8d;
  margin-bottom: 15px;
  font-size: 0.9em;
`;

const EmbedCodeContainer = styled.div`
  background: #2c3e50;
  color: #ecf0f1;
  padding: 20px;
  border-radius: 12px;
  font-family: 'Courier New', monospace;
  font-size: 0.85em;
  white-space: pre-wrap;
  overflow-x: auto;
  border-left: 4px solid #667eea;
  margin-top: 15px;
  line-height: 1.4;
`;

const CopyButton = styled.button`
  background: #667eea;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 12px;
  cursor: pointer;
  font-size: 0.9em;
  margin-top: 15px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover {
    background: #764ba2;
    transform: translateY(-2px);
  }
  
  &.copied {
    background: #27ae60;
  }
`;

const Loading = styled.div`
  text-align: center;
  padding: 40px;
  color: #7f8c8d;
  
  i {
    font-size: 2em;
    margin-bottom: 15px;
    color: #667eea;
  }
`;

const EmbedCode = () => {
  const [embedCode, setEmbedCode] = useState('');
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    generateEmbedCode();
  }, []);

  const generateEmbedCode = () => {
    setLoading(true);
    
    // Generate embed code
    const code = `<div style="width: 100%; max-width: 800px; margin: 0 auto;">
  <video
    id="holyTvPlayer"
    class="video-js vjs-default-skin vjs-big-play-centered"
    controls
    preload="auto"
    width="100%"
    height="450"
    data-setup="{}"
  >
    <source src="http://159.198.65.99:8000/live/holy_tv_livestream_key/index.m3u8" type="application/x-mpegURL">
    <p class="vjs-no-js">
      To view this video please enable JavaScript, and consider upgrading to a
      web browser that supports HTML5 video.
    </p>
  </video>
  
  <script src="https://vjs.zencdn.net/8.10.0/video.min.js"></script>
  <link href="https://vjs.zencdn.net/8.10.0/video-js.css" rel="stylesheet" />
  
  <script>
    var player = videojs('holyTvPlayer', {
      controls: true,
      autoplay: true,
      muted: false,
      liveui: true,
      responsive: true,
      fluid: true,
      html5: {
        hls: {
          enableLowInitialPlaylist: true,
          smoothQualityChange: true,
          backBufferLength: 30,
          maxBufferLength: 30,
          maxMaxBufferLength: 60,
          liveSyncDurationCount: 3,
          liveMaxLatencyDurationCount: 5
        }
      },
      liveTracker: {
        trackingThreshold: 0,
        liveTolerance: 5
      }
    });
  </script>
</div>`;

    setEmbedCode(code);
    setLoading(false);
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(embedCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy:', error);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = embedCode;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  if (loading) {
    return (
      <InfoPanel>
        <PanelHeader>
          <i className="fas fa-code"></i>
          <h3>Embed Code</h3>
        </PanelHeader>
        <PanelContent>
          <Loading>
            <i className="fas fa-spinner fa-spin"></i>
            <p>Generating embed code...</p>
          </Loading>
        </PanelContent>
      </InfoPanel>
    );
  }

  return (
    <InfoPanel>
      <PanelHeader>
        <i className="fas fa-code"></i>
        <h3>Embed Code</h3>
      </PanelHeader>
      <PanelContent>
        <EmbedDescription>
          Use this code to embed the stream on your website:
        </EmbedDescription>
        
        <EmbedCodeContainer>
          {embedCode}
        </EmbedCodeContainer>
        
        <CopyButton 
          onClick={handleCopy}
          className={copied ? 'copied' : ''}
        >
          <i className={copied ? 'fas fa-check' : 'fas fa-copy'}></i>
          {copied ? 'Copied!' : 'Copy Embed Code'}
        </CopyButton>
      </PanelContent>
    </InfoPanel>
  );
};

export default EmbedCode; 